export default "__VITE_ASSET__DPyZJzX8__"